import http from './http';
import { BASE } from './index';

/**
 * 发票管理相关接口
 */
export default {
  // 供应商开票管理列表
  supplierInvoiceList(params) {
    return http.post(`${BASE.PRO1}/supplier/invoice/auth/list`, params);
  },
  // 供应商开票导出
  supplierInvoiceExport(params) {
    return http.post(`${BASE.EXPORT_CENTER}/bi/supplier/invoice/auth/list/export`, params);
  },
  // 开通开票
  openInvoice(params) {
    return http.post(`${BASE.PRO1}/supplier/invoice/auth/pass`, params);
  },
  // 终止开票
  terminateInvoice(params) {
    return http.post(`${BASE.PRO1}/supplier/invoice/auth/close`, params);
  },
  // 供应商开票详情列表
  invoiceDetailList(params) {
    return http.post(`${BASE.PRO1}/invoice/list`, params);
  },
  // 供应商开票详情导出
  invoiceDetailExport(params) {
    return http.post(`${BASE.EXPORT_CENTER}/bi/invoice/list/export`, params);
  },
  // 税率配置列表
  taxRateConfigList(params) {
    return http.post(`${BASE.PRO1}/tax/rate/list`, params);
  },
  // 获取税率筛选菜单数据（品类树及税率枚举）
  taxRateSearchMenu(params) {
    return http.post(`${BASE.PRO1}/tax/rate/search/menu`, params);
  },
  // 更新单个税率配置
  updateTaxRateConfig(params) {
    return http.post(`${BASE.PRO1}/tax/rate/edit`, params);
  },
  // 批量更新税率配置
  batchUpdateTaxRateConfig(params) {
    return http.post(`${BASE.PRO1}/tax/rate/batch/edit`, params);
  }
};